
export enum SETTINGS_TAB {
  // ── Account (personal, no workspace needed) ──────────────────────────────
  PROFILE = 'profile',
  SECURITY_AND_API = 'security-and-api',

  // ── Workspace (admin only) ────────────────────────────────────────────────
  WORKSPACE = 'workspace',
  TEAM_ACCESS = 'team-access',
  ROLES_AND_PERMISSIONS = 'roles-and-permissions',
  BILLING_AND_USAGE = 'billing-and-usage',
  INTEGRATIONS = 'integrations',

  // ── Intelligence (admin only) ─────────────────────────────────────────────
  CHAMPIONS = 'champions',
  SIGNALS_AND_RULES = 'signals-and-rules',

  // ── Outreach (admin only) ─────────────────────────────────────────────────
  OUTREACH = 'outreach',
  EMAIL_UNSUBSCRIBES = 'email-unsubscribes',
  EMAIL_DIGEST = 'email-digest',

  // ── Notifications ─────────────────────────────────────────────────────────
  // Personal task alerts and workspace-level proactive policies share this tab.
  NOTIFICATIONS = 'notifications',

  // ── Technical (admin only) ────────────────────────────────────────────────
  MB_INTENT_CLIENT = 'mb-intent-client',

  // ── Support ───────────────────────────────────────────────────────────────
  FEEDBACK = 'feedback',

  // ── Super Admin ───────────────────────────────────────────────────────────
  SYSTEM_STATS = 'system-stats',
  SYSTEM_JOBS = 'system-jobs',
  FEATURE_ENABLEMENT = 'feature-enablement',
  USER_MAPPING = 'user-mapping',
  SYSTEM_WORKFLOWS = 'system-workflows',
  SYSTEM_AGENTS = 'system-agents',
  SIGNALS_ADMIN = 'signals-admin',
  EMAIL_SIGNATURES_ADMIN = 'email-signatures-admin',

  // ── Backward-compat aliases (redirect only, never shown in menu) ──────────
  GENERAL = 'general',
  SECURITY = 'security',
  API = 'api',
  MEMBERS = 'members',
  BILLING = 'billing',
  CREDITS_BILLING = 'credits-billing',
  USAGE_ANALYTICS = 'usage-analytics',
  CUSTOMER_RULES = 'customer-rules',
  SIGNAL_CONFIGURATION = 'signal-configuration',
  PHONE_NUMBERS = 'phone-numbers',
  POUNCE = 'pounce',
  MEETING_ROUTING = 'meeting-routing',
  SLACK_USER_MAPPING = 'slack-user-mapping',
  TEAMS_USER_MAPPING = 'teams-user-mapping',
}

// ── Redirect map for backward-compat URL params ───────────────────────────
export const SETTINGS_TAB_REDIRECTS: Partial<Record<SETTINGS_TAB, SETTINGS_TAB>> = {
  [SETTINGS_TAB.GENERAL]: SETTINGS_TAB.WORKSPACE,
  [SETTINGS_TAB.SECURITY]: SETTINGS_TAB.SECURITY_AND_API,
  [SETTINGS_TAB.API]: SETTINGS_TAB.SECURITY_AND_API,
  [SETTINGS_TAB.MEMBERS]: SETTINGS_TAB.BILLING_AND_USAGE,
  [SETTINGS_TAB.BILLING]: SETTINGS_TAB.BILLING_AND_USAGE,
  [SETTINGS_TAB.CREDITS_BILLING]: SETTINGS_TAB.BILLING_AND_USAGE,
  [SETTINGS_TAB.USAGE_ANALYTICS]: SETTINGS_TAB.BILLING_AND_USAGE,
  [SETTINGS_TAB.CUSTOMER_RULES]: SETTINGS_TAB.SIGNALS_AND_RULES,
  [SETTINGS_TAB.SIGNAL_CONFIGURATION]: SETTINGS_TAB.SIGNALS_AND_RULES,
  [SETTINGS_TAB.PHONE_NUMBERS]: SETTINGS_TAB.OUTREACH,
  [SETTINGS_TAB.POUNCE]: SETTINGS_TAB.OUTREACH,
  [SETTINGS_TAB.MEETING_ROUTING]: SETTINGS_TAB.OUTREACH,
  [SETTINGS_TAB.SLACK_USER_MAPPING]: SETTINGS_TAB.USER_MAPPING,
  [SETTINGS_TAB.TEAMS_USER_MAPPING]: SETTINGS_TAB.USER_MAPPING,
};
